module.exports = __webpack_public_path__ + "img/analyticsBg.b19366e8.png";